export default "skymp5-front/3165fa441dd663feeb5f67f7e427ba83.png";